import Image from "@tiptap/extension-image"

const IMAGE_ALIGNMENTS = ["left", "center", "right"]

function captionRoot(element) {
  if (element.matches?.("[data-article-image]")) return element
  return element.closest?.("[data-article-image]") || null
}

function attrsFromImageWrapper(element) {
  const img = element.querySelector("img")
  const src = img?.getAttribute("src")
  if (!src) return false

  return {
    src,
    alt: img.getAttribute("alt"),
    title: img.getAttribute("title"),
    width: img.getAttribute("width"),
    height: img.getAttribute("height"),
  }
}

export const ArticleAlignedImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      align: {
        default: "left",
        parseHTML: (element) => element.getAttribute("data-align"),
        renderHTML: (attributes) => {
          if (!IMAGE_ALIGNMENTS.includes(attributes.align)) return {}
          return { "data-align": attributes.align }
        },
      },
      caption: {
        default: "",
        parseHTML: (element) => captionRoot(element)?.querySelector("[data-article-caption]")?.textContent ?? null,
        renderHTML: () => ({}),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "div[data-article-image]",
        priority: 60,
        getAttrs: (element) => attrsFromImageWrapper(element),
      },
      ...(this.parent?.() || []),
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    const align = HTMLAttributes["data-align"]
    const wrapper = { "data-article-image": "true" }
    if (IMAGE_ALIGNMENTS.includes(align)) wrapper["data-align"] = align
    const children = [["img", HTMLAttributes]]
    const caption = node?.attrs?.caption
    if (caption) children.push(["p", { "data-article-caption": "true" }, caption])
    return ["div", wrapper, ...children]
  },

  addNodeView() {
    const parentView = this.parent?.()
    if (!parentView) return null

    return (props) => {
      const nodeView = parentView(props)
      const syncAlign = (node) => {
        const align = node.attrs.align
        if (IMAGE_ALIGNMENTS.includes(align)) nodeView.dom.dataset.align = align
        else delete nodeView.dom.dataset.align
      }
      const syncCaption = (node) => {
        const text = String(node.attrs.caption || "").trim()
        let captionEl = nodeView.dom.querySelector("[data-article-caption]")
        if (!text) {
          captionEl?.remove()
          return
        }
        if (!captionEl) {
          captionEl = document.createElement("p")
          captionEl.dataset.articleCaption = "true"
          nodeView.dom.appendChild(captionEl)
        }
        captionEl.textContent = text
      }
      syncAlign(props.node)
      syncCaption(props.node)
      const update = nodeView.update?.bind(nodeView)
      nodeView.update = (node, decorations, innerDecorations) => {
        const ok = update ? update(node, decorations, innerDecorations) : true
        if (ok) {
          syncAlign(node)
          syncCaption(node)
        }
        return ok
      }
      return nodeView
    }
  },
})
